import * as m from "mithril";
import { DropOffOrderDTO, MoneyDTO, PickUpOrderDTO, SeatOrderDTO, SeatSelectionDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import { formatMoney } from "../../helpers/MoneyFormatter";


interface SubtotalDetailsComponentAttrs {
  messageProvider: MessageProvider
  seatOrder: SeatOrderDTO
  pickUpOrder?: PickUpOrderDTO
  dropOffOrder?: DropOffOrderDTO
  subtotal: MoneyDTO
}

export function SubtotalDetailsComponent(): m.Component<SubtotalDetailsComponentAttrs> {

  return {
    view(vnode) {
      const { messageProvider, seatOrder, pickUpOrder, dropOffOrder, subtotal } = vnode.attrs;
      return m("div",
        m("div.font-weight-bold",
          messageProvider.get("subtotal.seats_pickup_dropoff_amount_details")
        ),

        m("div.row.mt-3",
          m(".col-6",
            m("span.mr-2", messageProvider.get("total_seat_price"))
          ),
          m(".col-6.text-right",
            m("span",
              formatMoney(seatOrder.totalAmount)
            )
          )
        ),

        (pickUpOrder && pickUpOrder.lineItems.length > 0) &&
        m("div.row.mt-3",
          m(".col-6",
            m("span.mr-2", messageProvider.get("total_pickup_fee"))
          ),
          m(".col-6.text-right",
            m("span",
              formatMoney(pickUpOrder.totalAmount)
            )
          )
        ),

        (dropOffOrder && dropOffOrder.lineItems.length > 0) &&
        m("div.row.mt-3",
          m(".col-6",
            m("span.mr-2", messageProvider.get("total_dropoff_fee"))
          ),
          m(".col-6.text-right",
            m("span",
              formatMoney(dropOffOrder!.totalAmount)
            )
          )
        ),

        m("div.row.mt-3 pt-3", {
          style: "border-top: 1px dashed #a7b5d0ff !important"
        },
          m(".col-6",
            m("span.mr-2", messageProvider.get("total_seats_price_plus_pickup_dropoff_fee"))
          ),
          m(".col-6.text-right",
            m("span.text-success.font-weight-bold",
              formatMoney(subtotal)
            )
          )
        )
      )
    }
  };
}
